import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import collab from "../assets/images/pixelogo.png";
import { RecentAvatars, VipComp, CoinQSComp, Gallery, LatestNews } from "../components/compIndex";

const content = {
  "Latest News": LatestNews,
  "VIP": VipComp,
  "Avatars": RecentAvatars,
  "Gallery": Gallery,
  "Coin & QS": CoinQSComp,
};

const Home = () => {
  const tabNames = Object.keys(content);
  const [activeTab, setActiveTab] = useState(tabNames[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentIndex = tabNames.indexOf(activeTab);
      const nextIndex = (currentIndex + 1) % tabNames.length;
      setActiveTab(tabNames[nextIndex]);
    }, 180000);
    return () => clearInterval(interval);
  }, [activeTab, tabNames]);

  return (
    <div className="flex md:flex-row flex-col p-4 md:p-2 gap-4">
      {/* Right Section - Moved to top on mobile */}
      <div className="w-full md:w-1/3 lg:w-1/4 md:ml-auto order-1 md:order-2 p-4 md:p-8 flex flex-col items-center bg-[var(--main-bg-color)] rounded-xl">
        <img 
          src={collab} 
          alt="PixeLore & Pixels" 
          className="w-40 h-40 md:w-60 md:h-60 rounded-full border-double border-4 border-silver-200 bg-[var(--panel-bg-color)]" 
        />
        <h2 className="text-xl md:text-2xl mt-4 mb-4 text-[var(--text-color)] font-heading bg-[var(--panel-bg-color)] p-4 rounded-lg shadow-md text-center">
          Hello, I'm PixeLore!
          <br />↪ I'm here to guide you on your Pixels Adventure!
        </h2>
        <Link
          to="/wiki/beginner"
          className="mt-4 px-6 py-2 bg-[var(--button-bg-color)] text-[var(--text-color)] rounded-lg shadow-md hover:shadow-lg hover:bg-[var(--button2-bg-color)] hover:text-[var(--text2-color)] transition"
        >
          Start Your Journey
        </Link>
      </div>

      {/* Left Section - Tabs and Content */}
      <div className="w-full order-2 md:order-1 p-4 md:p-8 space-y-4 bg-[var(--main-bg-color)] rounded-xl">
        <div className="flex flex-wrap justify-center gap-2 mb-4">
          {tabNames.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-3 py-2 rounded-lg font-bold text-xs md:text-sm ${
                activeTab === tab 
                  ? "bg-[var(--button-bg-color)] text-[var(--text-color)]" 
                  : "bg-[var(--button2-bg-color)] text-[var(--text2-color)]"
              } hover:shadow-md min-w-[100px]`}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="p-4 md:p-6 text-center text-[var(--text-color)] bg-[var(--panel-bg-color)] rounded-lg shadow-md">
          {React.createElement(content[activeTab])}
        </div>
      </div>
    </div>
  );
};

export default Home;